import { ContentCopy } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { useGlobalAlert } from "hooks/useAlert";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import { Inventory } from "types/inventory";

export const InventoryCreateInternalITInventoryButton = ({ inventory }: { inventory?: Inventory }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Duplicate as Internal IT Inventory" disableInteractive>
        <IconButton color="primary" onClick={handleOpen}>
          <ContentCopy />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Duplicate inventory as Internal IT Inventory</DialogTitle>
        <DialogContent>
          <Typography>
            This action will duplicate the inventory to use as an internal IT inventory. Are you sure you want to
            perform this action?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() =>
              api
                .post(`/inventories/${inventory?.id}/create_internal_it_inventory`)
                .then((response) => {
                  useGlobalAlert.alertSuccess("Internal IT asset created successfully.");
                  navigate(`/pickups/${response.data.pickup.id}/inventories/${response.data.id}`);
                })
                .catch(() => useGlobalAlert.alertError("Failed to perform action."))
                .finally(() => handleClose())
            }
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
